import styled, { css } from 'styled-components';

import { joinWithComma } from '../../../common/helpers/joinWithComma.helper';
import { theme } from '../../../common/ui/theme';

import { CoreInputProps } from './CoreInput';
import { LeadingVisualWrapper } from './LeadingVisualWrapper';
import { TrailingVisualWrapper } from './TrailingVisualWrapper';

export interface InputContainerProps extends Pick<CoreInputProps, 'disabled'> {
    $isFocused: boolean;
    $positive?: boolean;
    $negative?: boolean;
}

const positiveStyles = css`
    box-shadow: ${theme.shadows.border.positive};
`;

const negativeStyles = css`
    box-shadow: ${theme.shadows.border.negative};
`;

const focusedStyles = css<InputContainerProps>`
    box-shadow: ${(props) => {
        if (props.$negative) {
            return joinWithComma(theme.shadows.border.negative, theme.shadows.focus);
        }
        if (props.$positive) {
            return joinWithComma(theme.shadows.border.positive, theme.shadows.focus);
        }
        return joinWithComma(theme.shadows.focus, theme.shadows.border.default);
    }};
`;

const disabledStyles = css`
    box-shadow: ${theme.shadows.border.disabled};
`;

export const InputContainer = styled.div<InputContainerProps>`
    display: flex;
    align-items: center;
    position: relative;
    color: ${theme.colors.foreground.default};
    background-color: ${(props) => (props.disabled ? theme.colors.background.subtle : theme.colors.background.default)};
    outline: none;

    font-size: ${theme.fontSizes[14]};
    font-weight: ${theme.fontWeights[400]};
    line-height: 24px;

    margin: 0;
    width: 100%;
    height: 32px;

    border: none;
    border-radius: 6px;
    box-shadow: ${theme.shadows.border.default};

    transition: box-shadow 75ms;

    input:placeholder-shown ~ ${TrailingVisualWrapper} {
        color: ${theme.colors.foreground.subtle};
    }

    ${LeadingVisualWrapper}:has(~ input:placeholder-shown) {
        color: ${theme.colors.foreground.subtle};
    }

    ${(props) => (props.disabled ? disabledStyles : null)}
    ${(props) => (props.$positive ? positiveStyles : null)}
    ${(props) => (props.$negative ? negativeStyles : null)}
    ${(props) => (props.$isFocused ? focusedStyles : null)}
`;
